import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

const toSxArray = (sx) => {
  return (Array.isArray(sx) ? sx : [sx]).filter((item) => item != null);
};

const cardContainerSx = {
  display: 'flex',
  height: '176px',
  padding: '24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  alignSelf: 'stretch',
  borderRadius: '16px',
  border: '1px solid var(--Gray---Line-Stroke, #71767A)',
  background: 'var(--white-bi, #FFF)',
};

const titleSx = {
  color: 'var(--Gray-Darkest---Body-Text, #121A22)',
  fontFamily: 'Noto Sans',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '150%',
};

const noDataMessageSx = {
  mt: 'auto',
  fontSize: {
    lg: '13px',
    md: '14px',
    sm: '14px',
    xs: '14px',
  },
  fontWeight: 400,
  fontFamily: 'Noto Sans',
  color: '#121A22',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
};

export const MetricCardLoadingState = ({ width, height, borderRadius = '26px' }) => (
  <Box
    sx={{
      width,
      height,
      borderRadius,
      bgcolor: '#F8F8F8',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      p: 2,
    }}
  >
    <Skeleton variant="text" width="60%" height={24} sx={{ mb: 1 }} />
    <Skeleton variant="rectangular" width={150} height={32} sx={{ mb: 2, borderRadius: '4px' }} />
    <Skeleton variant="text" width="80%" height={32} />
  </Box>
);

export const MetricCardNoDataText = ({ sx, message = 'Available when more data is collected.' }) => (
  <Typography sx={[noDataMessageSx, ...toSxArray(sx)]}>
    {message}
  </Typography>
);

export const MetricCardErrorState = ({ title, titleSx: customTitleSx, subtitle, headerRight, message = 'Available when more data is collected.' }) => (
  <Box sx={cardContainerSx}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'stretch' }}>
      <Typography sx={[titleSx, ...toSxArray(customTitleSx)]}>
        {title}
      </Typography>
      {headerRight}
    </Box>
    {subtitle ? (
      <Typography
        sx={{
          color: 'var(--Gray-Darkest---Body-Text, #121A22)',
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '150%',
          mt: '-4px',
        }}
      >
        {subtitle}
      </Typography>
    ) : null}
    <MetricCardNoDataText message={message} />
  </Box>
);
